import React, { useState, useEffect } from "react";
import Axios from "axios";
import Navbar from "../components/Navbar";
import { ToastContainer, toast } from "react-toastify";
import { app_store, play_store, huawei_store } from "../images";
import { portal_url } from "../utils/Api";
import { Url_V1, Url_V2 } from "../utils/config";
import { Base64 } from "js-base64";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Banner from "../components/Banner";

const Login = () => {
  useEffect(() => {
    localStorage.setItem("apiToken", "");
    localStorage.setItem("username", "");
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  //========== VARIABLE ============

  const [windowSize] = useState(getWindowSize());
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  let data = [];
  let getError = "Processing to login";

  //========== METHODS ============
  const doLogin = async () => {
    await Axios.post(`${portal_url}/api/single_login`, {
      username: username,
      password: password,
    })
      .then((res) => {
        if (res.data.platform === "gps_id_v1") {
          toastNotif("success", "Login Successfully");
          setTimeout(() => {
            data = JSON.stringify({
              RequestUserName: username,
              RequestPassword: password,
              RequestLanguage: "en",
            });

            window.location = `${Url_V1}/log.php?apiKey=${Base64.btoa(data)}`;
          }, 2000);
        } else {
          if (res.data.status === true) {
            data = res.data.message.data;
            getProfil();
          }
        }
      })
      .catch((error) => {
        if (typeof error.response.data.message !== "undefined") {
          getError = error.response.data.message;
        }
        toastNotif("error", getError);
      });
  };

  const getProfil = async () => {
    await Axios.get(`${portal_url}/api/profile`, {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    })
      .then((res) => {
        const myApp = res.data.message.data;
        if (myApp.apps.apps.indexOf(2) !== -1) {
          toastNotif("success", "Login Successfully");
          setTimeout(() => {
            window.location = `${Url_V2}/login/${data.token}?isGenerate=${data.isGenerate}`;
          }, 2000);
        } else {
          toastNotif("error", "Don't have access to tracking system");
        }
      })
      .catch((error) => {
        if (typeof error.response.data.message !== "undefined") {
          getError = error.response.data.message;
        }
        toastNotif("error", getError);
      });
  };

  const doDemo = async () => {
    await Axios.post(`${portal_url}/api/demo_login`, {
      apikey: "1b1f5d489651898e2519736efacc8ac2",
    })
      .then((res) => {
        toastNotif("success", "Login demo Successfully");
        if (res.data.status === true) {
          setTimeout(() => {
            let data = res.data.message.data;
            window.location = `${Url_V2}/login/${data.token}`;
          }, 2000);
        }
      })
      .catch((error) => {
        if (typeof error.response.data.message !== "undefined") {
          getError = error.response.data.message;
        }
        toastNotif("error", getError);
      });
  };

  const toastNotif = (type, message) => {
    toast(message, {
      position: "top-right",
      autoClose: 1000,
      type: type,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      doLogin();
    }
  };

  const showPlayStore = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.superspring.gpsid",
      "_blank"
    );
  };

  const showAppStore = () => {
    window.open(
      "https://apps.apple.com/id/app/gps-id-dari-super-spring/id1119572414",
      "_blank"
    );
  };

  const showHuaweiStore = () => {
    window.open("https://appgallery.huawei.com/app/C108220087", "_blank");
  };

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  return (
    <div>
      <Navbar />
      <div className="container box-tagline">
        <div className="row">
          <div className="col-md-6">
            <span className="tagline">
              Kontrol dan akses <br />
              lebih dari 20 macam laporan perjalanan <br />
              armada anda melalui aplikasi & website
            </span>
          </div>
        </div>
      </div>
      <div
        className="container"
        style={{ marginTop: windowSize.innerWidth > 780 ? "20px" : "-20px" }}
      >
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-12">
                <Banner />
              </div>
            </div>
            <div className="row ios-app" style={{ marginTop: "20px" }}>
              <div
                className="d-flex flex-row bd-highlight"
                style={{ width: "20vw", height: "7.2vh" }}
              >
                <img
                  src={app_store}
                  alt=""
                  className="ios-image img-fluid"
                  style={{ cursor: "pointer" }}
                  onClick={() => showAppStore()}
                />
                <img
                  src={play_store}
                  alt=""
                  className="app-image img-fluid"
                  style={{ cursor: "pointer" }}
                  onClick={() => showPlayStore()}
                />
                <img
                  src={huawei_store}
                  alt=""
                  className="app-image img-fluid"
                  style={{ cursor: "pointer" }}
                  onClick={() => showHuaweiStore()}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="row"
              style={{
                marginTop: windowSize.innerWidth > 780 ? "-35px" : "-8vh",
              }}
            >
              <div className="col-12">
                <div className="ms-2 me-2">
                  <label
                    htmlFor="exampleInputUsername"
                    className="form-label text-label-username"
                    style={{
                      marginTop: windowSize.innerWidth > 780 ? "20px" : "-20px",
                    }}
                  >
                    Username
                  </label>
                  <input
                    type="text"
                    className="form-control text-input"
                    id="exampleInputUsername"
                    placeholder="Masukan Username Anda"
                    style={{ fontSize: "13px" }}
                    onChange={(e) => setUsername(e.target.value)}
                    onKeyDown={(e) => _handleKeyDown(e)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="ms-2 me-2">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="form-label text-label-password"
                  >
                    Password
                  </label>
                  <div className="input-group">
                    <input
                      type={passwordType}
                      className="form-control text-input"
                      id="exampleInputPassword1"
                      placeholder="Masukan Password Anda"
                      style={{ fontSize: "13px" }}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e) => _handleKeyDown(e)}
                    />
                    <span
                      className="input-group-text px-3"
                      id="basic-addon2"
                      style={{
                        backgroundColor: "white",
                        marginTop: "-10px",
                        height: "55px",
                      }}
                      onClick={togglePassword}
                    >
                      {passwordType === "password" ? (
                        <FontAwesomeIcon icon="eye-slash" />
                      ) : (
                        <FontAwesomeIcon icon="eye" />
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row" style={{ marginTop: "-15px" }}>
              <div className="col-12">
                <div className="d-flex bd-highlight">
                  <div className="me-auto p-2 bd-highlight">
                    <input
                      type="checkbox"
                      className="form-check-input chekbox"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "20px",
                      }}
                      id="exampleCheck1"
                    />
                    <label
                      className="form-check-label chexbox-label"
                      htmlFor="exampleCheck1"
                    >
                      Ingat Masuk
                    </label>
                  </div>
                  <div className="p-2 bd-highlight" style={{ marginTop: 1 }}>
                    <span className="forgot-password">
                      <u>Lupa Password?</u>
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
            <div
              className="row"
              style={{
                marginTop: windowSize.innerWidth > 780 ? "-40px" : "-5.5vh",
              }}
            >
              <div className="col-12">
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary btn-submit"
                      onClick={() => doLogin()}
                    >
                      Masuk
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn-coba-demo"
                      onClick={() => doDemo()}
                    >
                      <span className="text-coba-demo">Coba Demo</span>
                    </button>
                  </div>
                </div>

                {/* <div className="row">
                  <div className="col-12">
                    <p className="text-daftar">
                      Belum punya akun?{" "}
                      <span style={{ fontWeight: 700 }}>
                        <span
                          style={{ color: "black", textDecoration: "none" }}
                        >
                          Daftar
                        </span>
                      </span>
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="row ios-app2" style={{ marginTop: "20px" }}>
              <div
                className="d-flex flex-row bd-highlight"
                style={{ width: "150px" }}
              >
                <img
                  src={app_store}
                  alt=""
                  className="ios-image2 img-fluid"
                  style={{ cursor: "pointer" }}
                  onClick={() => showAppStore()}
                />
                <img
                  src={play_store}
                  alt=""
                  className="app-image2 img-fluid"
                  style={{ cursor: "pointer" }}
                  onClick={() => showPlayStore()}
                />
                <img
                  src={huawei_store}
                  alt=""
                  className="app-image2 img-fluid"
                  style={{ cursor: "pointer" }}
                  onClick={() => showHuaweiStore()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
